const ElementIds = {
    COMPARING_RESULT_WRAPPER_ID: 'COMPARING_RESULT_WRAPPER_ID',
    KW_INPUT_ID: 'keywordInput',
    RESULT_TABLE_WRAPPER_ID: 'RESULT_TABLE_WRAPPER_ID',
    HEADER: 'HEADER',
};

export default ElementIds;
